<script setup lang="ts">
import WarningModal from '../ui/reserve&reserve-flow/WarningModal.vue';
const emit = defineEmits<{
    close: [args: boolean];
}>();
</script>
<template>
    <mr-simple-modal>
        <WarningModal service="rating" @close="emit('close', $event)" />
    </mr-simple-modal>
</template>
